import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, Self } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'checkbox-list',
  templateUrl: './checkbox-list.html',
  styleUrls: ['./checkbox-list.scss'],
})
export class CheckboxListViewComponent implements OnChanges {

  @Input() dataSource: any;
  @Input() disabled: boolean;
  @Input() columnClass: string = "col-sm-6";

  @Output() selectedChanged = new EventEmitter<any>();

  public constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.dataSource) {
      return;
    }

    if (changes["dataSource"]) {

      let change = changes["dataSource"];

      if (change.currentValue && change.currentValue.length > 0) {

        change.firstChange = false;

        this.dataSource = this.prepareSource();

        this.selectedChanged.next({ currentItem: null, isChecked: null, selectedItems: this.dataSource });
      }
    }

    if (changes["disabled"]) {

      let change = changes["disabled"];

      if (change.currentValue) {

        this.dataSource.forEach(row => {

          row.disabled = this.disabled;
          row.checked = !this.disabled;
        });
        return;

      }

      this.dataSource.forEach(row => {

        row.disabled = null;

        if (change.previousValue) {

          row.checked = true;
        }
      });
    }
  }
  

  prepareSource = function () {
  
    if (this.dataSource instanceof Array) {

      return this.dataSource;
    }

    return new Array();
  };

  change(e, row) {

    let updateItem = this.dataSource.find(this.findItem, row);

    updateItem.checked = e.target.checked;

    this.selectedChanged.next({ currentItem: row, isChecked: e.target.checked });
  }

  findItem(row) {
    let item = this;
    return row === this;
  }
}
